// src/components/Navbar.jsx

import React from "react";
import nhs_logo from "../images/nhs.svg";
import "./components.css"; // Ensure to import the CSS file for styles

export default function Header() {

  return (
    <nav className="header">
      <div className="left-side">
        <img src={nhs_logo} className="nhsLogo" alt="NHS Logo" />
      </div>
    </nav>
  );
}
